// eslint-disable-next-line
import React from "react";
import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import ProductPage from "./components/ProductPage";
import RegisterPage from "./components/RegisterPage";
import LoginPage from "./components/LoginPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import CategoryPage from "./components/CategoryPage";
import Logout from "./components/Logout";
import Profile from "./components/Profile";
import Modal from "./components/PutOnSale";
import Mynfts from "./components/Mynfts";
import OffsetCredits from "./components/OffsetCredits";
import BurnHistory from "./components/BurnHistory"
import AssetPage from "./components/AssetPage";
import EmailVerification from "./components/EmailVerification";
import Asset from "./components/Asset";
import EmailVerificationPage from "./components/EmailVerificationPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/home" element={<Home />} />
      <Route path="/emailVerification/:userId" element={<EmailVerificationPage />} />
      <Route path="/product/:tokenId/:tokenAddress" element={<ProductPage />} />
      <Route path="/asset/:tokenId/:assetType" element={<AssetPage />} />
      <Route path="/asset/:tokenId/:assetType" element={<Asset />} />
      <Route path="/register" element={<RegisterPage />} />
      {/* <Route path="/connection" element={<WalletPage />} /> */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/resetpassword/:userId" element={<ResetPasswordPage />} />
      {/* <Route path="/Profile" element={<Profile />} /> */}
      <Route path="/category/:category" element={<CategoryPage />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/getFunds" element={<getFunds />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/save" element={<Modal />} />
      <Route path="/Mynfts" element={<Mynfts />} />
      <Route path="/OffsetCredits" element={<OffsetCredits />} />
      <Route path="/OffsetCredits/:tokenId" element={<BurnHistory />} />
    </Routes>
  );
}

export default App;
